import _ from "lodash";
import  config from "../../config/config";


const env = config[process.env.COUNTRY_CODE] ? config[process.env.COUNTRY_CODE] : config;

const NAV_FAVORITE_SPORTS_KEY = env.dropMenu.navKeys.favoriteSports
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
const NAV_MAIN_SPORTS_KEY = env.dropMenu.navKeys.mainSports
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
const NAV_OTHER_SPORTS_KEY = env.dropMenu.navKeys.otherSports
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
const NAV_UNION_SPORTS_KEY = env.dropMenu.navKeys.unionSports
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
const NAV_THIRD_ROW_KEY = env.dropMenu.navKeys.thirdRow
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
const NAV_NOTIFICATION_DOT_KEY = env.dropMenu.navKeys.notificationDot
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
// const NAV_FAVORITE_SPORTS_KEY = "nav-favorite-sports-v23";
// const NAV_MAIN_SPORTS_KEY = "nav-main-sports-v23";
// const NAV_OTHER_SPORTS_KEY = "nav-other-sports-v23";
// const NAV_UNION_SPORTS_KEY = "nav-union-sports-v23";
// const NAV_THIRD_ROW_KEY = "nav-third-row-v23";
// const NAV_NOTIFICATION_DOT_KEY = "nav-notification-dot-v23";
//Update NAV_ALL_SPORTS_KEY in App.js loadSportsList function

//Delete previous keys
// localStorage.removeItem("nav-favorite-sports-v22");
// localStorage.removeItem("nav-main-sports-v22");
// localStorage.removeItem("nav-other-sports-v22");
// localStorage.removeItem("nav-union-sports-v22");
// localStorage.removeItem("nav-third-row-v22");
// localStorage.removeItem("nav-all-sports-v22");


//Delete previous keys
const PREVIOUS_NAV_FAVORITE_SPORTS_KEY = env.dropMenu.navKeys.favoriteSports
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.previousVersion.toLowerCase());
const PREVIOUS_NAV_MAIN_SPORTS_KEY = env.dropMenu.navKeys.mainSports
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.previousVersion.toLowerCase());
const PREVIOUS_NAV_OTHER_SPORTS_KEY = env.dropMenu.navKeys.otherSports
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.previousVersion.toLowerCase());
const PREVIOUS_NAV_UNION_SPORTS_KEY = env.dropMenu.navKeys.unionSports
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.previousVersion.toLowerCase());
const PREVIOUS_NAV_THIRD_ROW_KEY = env.dropMenu.navKeys.thirdRow
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.previousVersion.toLowerCase());
const PREVIOUS_NAV_ALL_SPORTS_KEY = env.dropMenu.navKeys.allSports
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.previousVersion.toLowerCase());
const PREVIOUS_NAV_NOTIFICATION_DOT_KEY = env.dropMenu.navKeys.notificationDot
	.replace("{country}", env.countryCode.toLowerCase())
	.replace("{version}", env.dropMenu.navKeys.previousVersion.toLowerCase());

localStorage.removeItem(PREVIOUS_NAV_FAVORITE_SPORTS_KEY);
localStorage.removeItem(PREVIOUS_NAV_MAIN_SPORTS_KEY);
localStorage.removeItem(PREVIOUS_NAV_OTHER_SPORTS_KEY);
localStorage.removeItem(PREVIOUS_NAV_UNION_SPORTS_KEY);
localStorage.removeItem(PREVIOUS_NAV_THIRD_ROW_KEY);
localStorage.removeItem(PREVIOUS_NAV_ALL_SPORTS_KEY);
localStorage.removeItem(PREVIOUS_NAV_NOTIFICATION_DOT_KEY);


const state = {
	favoriteSports: localStorage.getItem(NAV_FAVORITE_SPORTS_KEY)
		? JSON.parse(localStorage.getItem(NAV_FAVORITE_SPORTS_KEY))
		: [],
	mainSports: localStorage.getItem(NAV_MAIN_SPORTS_KEY)
		? JSON.parse(localStorage.getItem(NAV_MAIN_SPORTS_KEY))
		: [],
	otherSports: localStorage.getItem(NAV_OTHER_SPORTS_KEY)
		? JSON.parse(localStorage.getItem(NAV_OTHER_SPORTS_KEY))
		: [],
	unionSports: localStorage.getItem(NAV_UNION_SPORTS_KEY)
		? JSON.parse(localStorage.getItem(NAV_UNION_SPORTS_KEY))
		: [],
	thirdRow: localStorage.getItem(NAV_THIRD_ROW_KEY)
		? JSON.parse(localStorage.getItem(NAV_THIRD_ROW_KEY))
		: [],
	notificationDot: localStorage.getItem(NAV_NOTIFICATION_DOT_KEY)
		? JSON.parse(localStorage.getItem(NAV_NOTIFICATION_DOT_KEY))
		: {
				visited: false,
				visible: false,
		  },
};

const persistNavGroup = (navGroup, key) => {
	localStorage.setItem(key, JSON.stringify(navGroup));
};

const getters = {
	favoriteSports: (state) => {
		return state.favoriteSports ? state.favoriteSports : [];
	},
	mainSports: (state) => {
		return state.mainSports ? state.mainSports : [];
	},
	otherSports: (state) => {
		return state.otherSports ? state.otherSports : [];
	},
	unionSports: (state) => {
		return state.unionSports ? state.unionSports : [];
	},
	thirdRow: (state) => {
		return state.thirdRow ? state.thirdRow : [];
	},
	notificationDot: (state) => {
		return state.notificationDot
			? state.notificationDot
			: {
					visited: false,
					visible: false,
			  };
	},
};

const actions = {
	updateUnionSports({ commit }) {
		const unionSports = _.union(
			state.mainSports,
			state.otherSports,
			state.thirdRow
		);
		commit("setUnionSports", unionSports);
	},
	updateNotificationDotVisible({ commit, state }, visible) {
		let notificationDotState = state.notificationDot;
		notificationDotState.visible = visible;
		commit("setNotificationDot", notificationDotState);
	},
	updateNotificationDotVisited({ commit, state }, visited) {
		let notificationDotState = state.notificationDot;
		notificationDotState.visited = visited;
		commit("setNotificationDot", notificationDotState);
	},
	clearMainSports({commit}){
		const NAV_MAIN_SPORTS_KEY = env.dropMenu.navKeys.mainSports
			.replace("{country}", env.countryCode.toLowerCase())
			.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
		localStorage.removeItem(NAV_MAIN_SPORTS_KEY);

		commit("setMainSports", []);
	},
	clearOtherSports({commit}){
		const NAV_OTHER_SPORTS_KEY = env.dropMenu.navKeys.otherSports
			.replace("{country}", env.countryCode.toLowerCase())
			.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
		localStorage.removeItem(NAV_OTHER_SPORTS_KEY);

		commit("setOtherSports", []);
	},
	clearUnionSports({commit}){
		const NAV_UNION_SPORTS_KEY = env.dropMenu.navKeys.unionSports
			.replace("{country}", env.countryCode.toLowerCase())
			.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
		localStorage.removeItem(NAV_UNION_SPORTS_KEY);

		commit("setUnionSports", []);
	},
	clearThirdRow({commit}){
		const NAV_THIRD_ROW_KEY = env.dropMenu.navKeys.thirdRow
			.replace("{country}", env.countryCode.toLowerCase())
			.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
		localStorage.removeItem(NAV_THIRD_ROW_KEY);

		commit("setThirdRow", []);
	},
	clearAllSports({commit}){
		const NAV_ALL_SPORTS_KEY = env.dropMenu.navKeys.allSports
			.replace("{country}", env.countryCode.toLowerCase())
			.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
		localStorage.removeItem(NAV_ALL_SPORTS_KEY);
	},
	clearFavoriteSports({commit}){
		const NAV_FAVORITE_SPORTS_KEY = env.dropMenu.navKeys.favoriteSports
			.replace("{country}", env.countryCode.toLowerCase())
			.replace("{version}", env.dropMenu.navKeys.currentVersion.toLowerCase());
		localStorage.removeItem(NAV_FAVORITE_SPORTS_KEY);

		commit("setFavoriteSports", []);
	},
};

const mutations = {
	setFavoriteSports(state, sports) {
		state.favoriteSports = sports;
		persistNavGroup(state.favoriteSports, NAV_FAVORITE_SPORTS_KEY);
	},
	setMainSports(state, sports) {
		state.mainSports = sports;
		persistNavGroup(state.mainSports, NAV_MAIN_SPORTS_KEY);
	},
	setOtherSports(state, sports) {
		state.otherSports = sports;
		persistNavGroup(state.otherSports, NAV_OTHER_SPORTS_KEY);
	},
	setUnionSports(state, sports) {
		state.unionSports = sports;
		persistNavGroup(state.unionSports, NAV_UNION_SPORTS_KEY);
	},
	setThirdRow(state, items) {
		state.thirdRow = items;
		persistNavGroup(state.thirdRow, NAV_THIRD_ROW_KEY);
	},
	setNotificationDot(state, notificationDot) {
		state.notificationDot = notificationDot;
		persistNavGroup(state.notificationDot, NAV_NOTIFICATION_DOT_KEY);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
